import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ParseKeyData } from './ParseKeyData';
import { ConfigDataTable } from './ConfigDataTable';

function extractTableData(keyData, keyColumns) {
  const parts = [];
  for (const part of keyData)
  {
    const columns = {};
    columns['Serial_Num'] = part.serialNumber;
    const xmlAttribs = ParseKeyData(part.keyData); 
    xmlAttribs.forEach(item => {if (keyColumns.includes(item.AttrName))  {columns[item.AttrName] = item.AttrValue}});
    parts.push(columns);
  }
  return parts;
}

export default function Parts({ onItemSelect }) {
  const { cacheParts, selectedPart, partAttribute } = useSelector(state => state.rules);
  const [activeIndex, setActiveIndex] = useState(null);
  const keyColumns = ['BasePart','StartPart_Rev','Raw_Mat_Code'];
  const [ parts, setParts ] = useState(extractTableData(cacheParts, keyColumns));

  useEffect(() => {
    const addColumn = extractTableData(cacheParts, [...keyColumns, ...partAttribute])
    setParts(addColumn.filter(item => (partAttribute.length === 0 || Object.keys(item).some(i => partAttribute.includes(i)))));
  }, [cacheParts, partAttribute])

  const handleClick = (index, item) => {
    setActiveIndex(index);
    onItemSelect(cacheParts[index]);
  }

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowUp') {
      const newIndex = Math.max(0, activeIndex - 1);
      setActiveIndex(newIndex);
      onItemSelect(cacheParts[newIndex]);
      event.preventDefault(); 
    } else if (event.key === 'ArrowDown') {
      const newIndex = Math.min(cacheParts.length - 1, activeIndex + 1);
      setActiveIndex(newIndex);
      onItemSelect(cacheParts[newIndex]);
      event.preventDefault();
    }
  };

  return (
    <pre className="p-2 rounded text-sm text-left overflow-x-auto overflow-y-auto" >
        <ConfigDataTable data={parts} activeIndex={activeIndex} onRowClick={handleClick} onRowArrow={handleKeyDown}  />
    </pre>
  )
}